import "../styles/index.scss";
require('typeface-inter');

console.info("webpacker loaded")
